var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "hidden sm:block overflow-y-scroll"
  }, [_c('div', {
    staticClass: "flex flex-col bg-white min-h-full transition-all duration-100 ease-in w-max-content w-max max-w-64 xxl:max-w-72 2xl:max-w-80 relative z-10",
    class: {
      'absolute xl:relative': _vm.hover
    },
    on: {
      "mouseover": function ($event) {
        _vm.hover = true;
      },
      "mouseleave": _vm.reduceMenu
    }
  }, [_c('ul', {
    staticClass: "ml-5 mt-32"
  }, [_c('li', {
    staticClass: "list-none"
  }, [_c('ul', {
    staticClass: "pl-3"
  }, _vm._l(_vm.staticMenus, function (menu) {
    return _c('li', {
      class: {
        'text-gray-900 font-normal': true
      }
    }, [menu.pageName ? _c('router-link', {
      key: menu.libelle,
      staticClass: "hover:font-normal transition-all ease-in-out duration-150 block py-3 pr-10 font-light",
      attrs: {
        "to": {
          name: 'HelpContact'
        },
        "active-class": "border-r-4 border-indigo-600 py-5 font-semibold"
      }
    }, [_vm._v("\n              " + _vm._s(menu.libelle) + "\n            ")]) : menu.external ? _c('a', {
      staticClass: "py-5 pr-10 block font-light",
      attrs: {
        "href": menu.external,
        "target": menu.target
      }
    }, [_vm._v(_vm._s(menu.libelle))]) : _vm._e()], 1);
  }), 0)])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }